const pad = num => ((num < 10) ? `0${num}` : num);

const time12h = (hr, mn) => {
    const amStr = 'am';
    const pmStr = 'pm';

    if (hr === 0) {
        return `12.${pad(mn)} ${amStr}`;
    }
    if (hr < 12) {
        return `${hr}.${pad(mn)} ${amStr}`;
    }
    if (hr === 12) {
        return `12.${pad(mn)} ${pmStr}`;
    }
    return `${hr - 12}.${pad(mn)} ${pmStr}`;
};

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May',
    'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

export const formatTime = (date, UTC) => {
    const d = (date instanceof Date) ? date : new Date(date);
    return UTC ? time12h(d.getUTCHours(), d.getUTCMinutes())
               : time12h(d.getHours(), d.getMinutes());
};

export const formatTime24h = (date, UTC) => {
    const d = (date instanceof Date) ? date : new Date(date);
    return UTC ? `${d.getUTCHours()}.${pad(d.getUTCMinutes())}`
               : `${d.getHours()}.${pad(d.getMinutes())}`;
};

export const formatDate = (date, UTC) => {
    const d = (date instanceof Date) ? date : new Date(date);
    return UTC ? `${pad(d.getUTCDate())} ${monthNames[d.getUTCMonth()]} ${d.getUTCFullYear()}`
               : `${pad(d.getDate())} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatDateTime24h = (date, UTC) =>
`${formatTime24h(date, UTC)}, ${formatDate(date, UTC)}`;

export const formatDateTimeBetslip = (date, UTC) =>
`${formatTime24h(date, UTC)} on ${formatDate(date, UTC)}`;

export const formatDateTime = (date, UTC) =>
    `${formatTime(date, UTC)}, ${formatDate(date, UTC)}`;



// WEBPACK FOOTER //
// /src/js/common/utils/formatDateTime.js